var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.0498H3C2.80109 5.0498 2.61032 5.12882 2.46967 5.26947C2.32902 5.41013 2.25 5.60089 2.25 5.7998V18.5498C2.25 18.9476 2.40804 19.3292 2.68934 19.6105C2.97064 19.8918 3.35218 20.0498 3.75 20.0498H20.25C20.6478 20.0498 21.0294 19.8918 21.3107 19.6105C21.592 19.3292 21.75 18.9476 21.75 18.5498V5.7998C21.75 5.60089 21.671 5.41013 21.5303 5.26947C21.3897 5.12882 21.1989 5.0498 21 5.0498ZM19.0716 6.5498L12 13.0326L4.92844 6.5498H19.0716ZM20.25 18.5498H3.75V7.50512L11.4928 14.6029C11.6312 14.7299 11.8122 14.8004 12 14.8004C12.1878 14.8004 12.3688 14.7299 12.5072 14.6029L20.25 7.50512V18.5498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSimple);
export default __webpack_public_path__ + "static/media/EnvelopeSimple.944cb4b3c3d6d402cd4d27ce5c8128cb.svg";
export { ForwardRef as ReactComponent };